import { render, staticRenderFns } from "./HealthReportForm.vue?vue&type=template&id=184ff0cd"
import script from "./HealthReportForm.vue?vue&type=script&lang=ts"
export * from "./HealthReportForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports